import { ReactNode, useEffect, useState } from 'react';

import { UserConsent, userConsentDefaultValue, userConsentSetValue } from './context';

export const UserConsentProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState(userConsentDefaultValue);

  userConsentSetValue.current = setState;

  useEffect(() => {
    console.log(`UserConsentProvider: ${JSON.stringify(state)}`);
  }, [state]);

  return <UserConsent.Provider value={state}>{children}</UserConsent.Provider>;
};
